var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 1,
    y: 0,
    width: 270,
    height: 110,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.6%",
    y: "-4.5%",
    width: "105.2%",
    height: "112.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONCEPT_menu-_hoover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu_hoover",
    transform: "translate(-977.000000, -175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_hoover",
    transform: "translate(957.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 18,
    y: 3,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(19.000000, 4.000000)",
    fill: "#050202"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "5 9.5 15.915 9.5 15.915 8.5 5 8.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "12.6022 13.0896 11.9202 12.3576 15.5322 9.0006 11.9202 5.6436 12.6022 4.9106 17.0002 9.0006"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "9.5001 17.4998 0.5001 17.4998 0.5001 0.4998 9.5001 0.4998 9.5001 6.9998 8.5001 6.9998 8.5001 1.4998 1.5001 1.4998 1.5001 16.4998 8.5001 16.4998 8.5001 10.9998 9.5001 10.9998"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0,
    y: 0,
    width: 270,
    height: 26
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.6dcf223fc12d4fe16842d6cc75ea15d0.svg";
export { ForwardRef as ReactComponent };